import { RECURRING_INVOICE_EMAIL_TEMPLATE_RECIPIENTS_SEPARATOR } from '@features/recurringInvoices/constants/recurringInvoiceEmailTemplateRecipientsSeparator'
import { RecurringInvoiceDuration } from '@features/recurringInvoices/enums/recurringInvoiceDuration'
import { RecurringInvoiceSchedule } from '@features/recurringInvoices/types/recurringInvoiceSchedule'

import { RecurringInvoiceForm } from '../../types/recurringInvoiceForm/recurringInvoiceForm'

interface GetRecurringInvoiceFormValuesFromScheduleOptions {
  schedule?: RecurringInvoiceSchedule
  defaultValues: RecurringInvoiceForm
}

export const getRecurringInvoiceFormValuesFromSchedule = ({
  schedule,
  defaultValues,
}: GetRecurringInvoiceFormValuesFromScheduleOptions): RecurringInvoiceForm => {
  if (!schedule) {
    return defaultValues
  }

  const { action, startDate, confirmation, frequency, repeat, message } = schedule
  const duration = repeat === null ? RecurringInvoiceDuration.Indefinite : RecurringInvoiceDuration.Repeat

  return {
    delivery: action || defaultValues.delivery,
    deliveryNotification: confirmation !== undefined ? confirmation : defaultValues.deliveryNotification,
    duration: repeat === undefined ? defaultValues.duration : duration,
    firstInvoiceDate: startDate ? new Date(startDate) : defaultValues.firstInvoiceDate,
    frequency: frequency || defaultValues.frequency,
    occurrences: repeat || defaultValues.occurrences,
    message: {
      acceptStripePayment: message?.acceptStripePayment || false,
      body: message?.body || '',
      to: message?.to ? message.to.split(RECURRING_INVOICE_EMAIL_TEMPLATE_RECIPIENTS_SEPARATOR) : [],
    },
  }
}
